import React from "react";

const Privacy = () => {
  return (
    <div className="container mx-auto p-6 mt-44 text-gray-800">
   
      <section className="mb-6">
        <h1 className="text-xl font-semibold">Privacy Policy</h1>
        <p>Last Updated: [Insert Date]</p>
        <p>
          Welcome to Saiaquapets, the product of Aqua Fanatics Tech Private Limited. Your privacy is important to us, and this Privacy Policy outlines how we collect, use, and protect your information when you visit our website, <a href="https://saiaquapets.com" className="text-blue-600">saiaquapets.com</a> ("Site"). By using the Site, you agree to the practices described in this Privacy Policy.
        </p>
        <h3 className="text-lg font-semibold mt-4">1. Information We Collect</h3>
        <p>We may collect the following types of information:</p>
        <h4 className="text-md font-semibold">a. Personal Information</h4>
        <ul className="list-disc ml-6">
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Shipping/billing address</li>
          <li>Payment details (for purchases)</li>
          <li>Any details you voluntarily provide</li>
        </ul>
        <h4 className="text-md font-semibold">b. Non-Personal Information</h4>
        <ul className="list-disc ml-6">
          <li>IP addresses</li>
          <li>Browser type</li>
          <li>Pages visited</li>
          <li>Referring URLs</li>
          <li>Device type</li>
          <li>Date and time of visits</li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">2. How We Use Your Information</h3>
        <ul className="list-disc ml-6">
          <li>To process orders and deliver products</li>
          <li>To communicate with you</li>
          <li>To send newsletters (if opted-in)</li>
          <li>To improve user experience</li>
          <li>To comply with legal obligations</li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">3. Sharing of Your Information</h3>
        <p>We do not sell your personal information but may share it in these cases:</p>
        <ul className="list-disc ml-6">
          <li>With service providers (e.g., payment processors, shipping companies)</li>
          <li>To comply with legal obligations</li>
          <li>In case of a business transfer (merger, sale, etc.)</li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">4. Cookies and Tracking</h3>
        <p>We use cookies to improve functionality and analytics. You can manage cookie settings in your browser.</p>
        <h3 className="text-lg font-semibold mt-4">5. Data Security</h3>
        <p>We implement security measures to protect your data, though no method is 100% secure.</p>
        <h3 className="text-lg font-semibold mt-4">6. Your Rights</h3>
        <ul className="list-disc ml-6">
          <li>Access, update, or delete personal information</li>
          <li>Withdraw consent for marketing</li>
          <li>Object or restrict data processing</li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">7. Third-Party Links</h3>
        <p>We are not responsible for privacy practices of external sites linked on our Site.</p>
        <h3 className="text-lg font-semibold mt-4">8. Children's Privacy</h3>
        <p>Our Site is not intended for individuals under 13. If we collect personal data from a child, contact us for removal.</p>
        <h3 className="text-lg font-semibold mt-4">9. Changes to This Privacy Policy</h3>
        <p>We may update this Privacy Policy periodically. Check back for updates.</p>
        <h3 className="text-lg font-semibold mt-4">10. Contact Us</h3>
        <p>
          If you have any questions, contact us at <a href="mailto:support@saiaquapets.com" className="text-blue-600">support@saiaquapets.com</a>.<br />
          Phone: +91 7338701314<br />
          Address: KOCHAR BLISS 4TH FLOOR, NO.A8 and A9, Thiru Vi Ka Industrial Estate, Guindy, Tamil Nadu 600032
        </p>
      </section>
    </div>
  );
};

export default Privacy;
